"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var sdk_1 = require("./sdk");
var resources = {};
var cashierPayments = (function () {
    var instance = new sdk_1.default(resources);
    return {
        init: instance.init,
        on: instance.on,
        off: instance.off,
        reload: instance.reload,
        remove: instance.remove,
        render: instance.render,
        addMethod: instance.addMethod,
        getPaymentMethodMetadata: instance.getPaymentMethodMetadata,
        fetchPaymentMethodSettings: instance.fetchPaymentMethodSettings,
        setActivePaymentMethod: instance.setActivePaymentMethod,
        fetchSettings: instance.fetchSettings,
        fetchMandatoryFields: instance.fetchMandatoryFields,
        fetchPaymentMethodsByConfiguration: instance.fetchPaymentMethodsByConfiguration,
        logMandatoryFieldsValidationStatus: instance.logMandatoryFieldsValidationStatus,
        setMandatoryField: instance.setMandatoryField,
        getMandatoryFieldsMap: instance.getMandatoryFieldsMap,
        isRTLLocale: instance.isRTLLocale,
        tokenize: instance.tokenize,
        localizeError: instance.localizeError,
        continuePayment: instance.continuePayment,
        pay: instance.pay,
        initializePayment: instance.initializePayment,
        getCreditCardPublicData: instance.getCreditCardPublicData,
        launchPaymentPopup: instance.launchPaymentPopup,
        cancelPaymentPopup: instance.cancelPaymentPopup,
        resolveCountry: instance.resolveCountry,
        setCountry: instance.setCountry,
        setInstallments: instance.setInstallments,
        saveCreditCard: instance.saveCreditCard,
        updateSavedCreditCard: instance.updateSavedCreditCard,
        fetchSavedCreditCards: instance.fetchSavedCreditCards,
        fetchTokenForSavedCreditCard: instance.fetchTokenForSavedCreditCard,
        fetchSavedCreditCard: instance.fetchSavedCreditCard,
        deleteSavedCreditCard: instance.deleteSavedCreditCard,
        saveBillingAddress: instance.saveBillingAddress,
        updateSavedBillingAddress: instance.updateSavedBillingAddress,
        makeCreditCardPrimary: instance.makeCreditCardPrimary,
        charge: instance.charge,
        getOrder: instance.getOrder,
        submit: instance.submit,
        validate: instance.validate,
        collapse: instance.collapse,
        expand: instance.expand,
    };
})();
if (cashierPayments && typeof window === 'object') {
    window.cashierPayments = cashierPayments;
}
exports.default = cashierPayments;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-sdk/dist/src/index.js
// module id = 135
// module chunks = 0 1